<app-print-office-header></app-print-office-header>

<ion-content [fullscreen]="true">
  @if(printOrder(); as printOrder) {

  <ion-grid>
    <ion-row>
      <ion-col size="12" size-md="6">
        <ion-card class="order-info-card sp-card sp-card-texts">
          <ion-card-header>
            <ion-card-title>{{ 'PRINT.ORDER.CLIENT.TITLE' | translate }}:</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <ion-item lines="none">
              <ion-icon name="barcode-outline" color="primary"></ion-icon>
              <ion-label>{{ 'PRINT.ORDER.TRACKING_NUMBER' | translate }}:</ion-label>
              <ion-text>{{ printOrder.trackingNumber }}</ion-text>
            </ion-item>
            <ion-item lines="none">
              <ion-icon name="mail-outline" color="primary"></ion-icon>
              <ion-label>{{ 'PRINT.ORDER.CLIENT.EMAIL' | translate }}:</ion-label>
              <ion-text>{{ printOrder.email }}</ion-text>
            </ion-item>

            <ion-item lines="none">
              <ion-icon name="call-outline" color="primary"></ion-icon>
              <ion-label>{{ 'PRINT.ORDER.CLIENT.PHONE' | translate }}:</ion-label>
              <ion-text>{{ printOrder.mobilePhone }}</ion-text>
            </ion-item>

            <ion-item lines="none">
              <ion-icon name="chatbubble-ellipses-outline" color="primary"></ion-icon>
              <ion-label>{{ 'PRINT.ORDER.CLIENT.COMMENT' | translate }}:</ion-label>
              <ion-text>{{ printOrder.comment }}</ion-text>
            </ion-item>
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col size="12" size-md="6">
        <ion-card class="order-info-card sp-card sp-card-texts">
          <ion-card-header>
            <ion-card-title>{{ 'PRINT.ORDER.TITLE' | translate }}</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <ion-item lines="none">
              <ion-icon name="calendar-outline" color="primary"></ion-icon>
              <ion-label>{{ 'PRINT.ORDER.CREATED.DATE' | translate }}:</ion-label>
              <ion-text>{{ printOrder.createdAt | localizedDate }}</ion-text>
            </ion-item>

            <ion-item lines="none">
              <ion-icon name="cash-outline" color="primary"></ion-icon>
              <ion-label>{{ 'COMMON.PRICE' | translate }}:</ion-label>
              <ion-text>{{ printOrder.totalPrice }} {{ "CURRENCY.TEXT" | translate }}</ion-text>
            </ion-item>

            <ion-item lines="none">
              <ion-label>{{ 'PRINT.ORDER.STATUS' | translate }}:</ion-label>
              <ion-select
                [(ngModel)]="selectedStatus"
                (ionChange)="confirmStatusChange()"
                [class]="getStatusCssClass()"
                [okText]="selectCompomnentOkText()"
                slot="end"
                [cancelText]="selectCompomnentCancelText()">
                @for(status of printOrderStatuses; track $index) {
                <ion-select-option [value]="status"> {{ statusAsText(status) }} </ion-select-option>
                }
              </ion-select>
            </ion-item>

            <ion-item lines="none">
              <ion-label>{{ 'PRINT.ORDER.PAYMENT_STATUS' | translate }}:</ion-label>
              <ion-text
                [style.color]="
                  printOrder.paymentStatus == paymentStatuses.Rejected ||
                  printOrder.paymentStatus == paymentStatuses.NotPaid
                    ? 'red'
                    : 'green'
                "
                >{{ paymentStatusAsText(printOrder.paymentStatus) }}</ion-text
              >
            </ion-item>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <div class="files-section-title">
          <ion-text color="secondary" class="ion-margin d-flex">
            <h2>{{ 'PRINT.ORDER.FILES' | translate }}</h2>
          </ion-text>

          <ion-button color="secondary" (click)="downloadFilesInZip()" class="ion-margin"> Download ZIP </ion-button>
        </div>

        <app-custom-sp-table [columns]="fileColumns" [actions]="fileActions" [rowData]="printOrder.files || []">
        </app-custom-sp-table>
      </ion-col>
    </ion-row>
  </ion-grid>

  }
</ion-content>
